import StatusIcon, { StatusIconProps } from 'components/status/StatusIcon.tsx';
import React from 'react';
import { BankTransactionStatusType } from 'types/bank-transfers.ts';
import { getClassifierText } from 'utils/getTranslations.ts';
import { useClassifiers } from 'utils/useClassifiers.ts';

interface BankTransferStatusIconProps {
    bankTransactionStatusTypeCode: string;
    isWithTooltip?: boolean;
}

const BankTransferStatusIcon: React.FC<BankTransferStatusIconProps> = ({
    bankTransactionStatusTypeCode,
    isWithTooltip = true,
}) => {
    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({
        codes: ['BANK_TRANSACTION_STATUS_TYPE'],
    });

    const classifierText = isWithTooltip
        ? getClassifierText(classifiers['BANK_TRANSACTION_STATUS_TYPE'], bankTransactionStatusTypeCode)
        : undefined;

    let type: StatusIconProps['type'] | undefined = undefined;

    switch (bankTransactionStatusTypeCode) {
        case BankTransactionStatusType.NON_INVOICE:
            type = 'info';
            break;
        case BankTransactionStatusType.FULLY_USED:
            type = 'success';
            break;
        case BankTransactionStatusType.FULLY_USED_UNPAID:
            type = 'warning';
            break;
        case BankTransactionStatusType.NOT_FULLY_USED:
            type = 'error';
            break;
    }

    if (isLoadingClassifiers || type === undefined) {
        return null;
    }

    return <StatusIcon type={type} tooltipText={classifierText} />;
};

export default BankTransferStatusIcon;
